import { a as e, _ as t } from "./tslib.es6-7f1b1220.js";
import { c as n, u as o, h as i } from "./lit-element-161a1699.js";
import { p as r, d as s, c as l } from "./decorators-7e9cd43b.js";
import { BaseElement as a } from "./BaseElement.esm.min.js";
import { h as d } from "./host.styles-cf05db22.js";
import { i as c } from "./if-defined-123567fc.js";
const u = n`${o(":host {\n  --zui-picker-grid-cell-height: calc(var(--zui-gu) * 4);\n  --zui-picker-grid-cell-min-width: calc(var(--zui-gu) * 4);\n  --zui-picker-grid-cell-border: 1px solid;\n  width: var(--zui-picker-grid-cell-width, auto);\n  height: var(--zui-picker-grid-cell-height);\n  min-width: var(--zui-picker-grid-cell-min-width);\n}\n\n:host(:focus),\nbutton:focus {\n  outline: none;\n}\n\n:host([disabled]) button {\n  pointer-events: none;\n}\n:host([disabled]) span {\n  text-decoration: line-through;\n}\n\n:host([emphasis=selected]) button {\n  background: none;\n}\n\n:host([emphasis=selected]) button {\n  background: var(--zui-color-grid-cell-background-selected);\n}\n:host([emphasis=selected]) button:hover {\n  background: var(--zui-color-grid-cell-background-selected);\n}\n:host([emphasis=selected]) button:focus {\n  background: var(--zui-color-grid-cell-background-selected);\n}\n\n:host([emphasis=default]) button:hover,\n:host([emphasis=subtle]) button:hover {\n  border-color: var(--zui-color-grid-cell-border-hover);\n}\n:host([emphasis=default]) button:focus,\n:host([emphasis=subtle]) button:focus {\n  border-color: var(--zui-color-grid-cell-border-pressed);\n}\n\n:host([disabled][emphasis=default]) span {\n  color: var(--zui-color-grid-cell-text-default-disabled);\n  opacity: 0.5;\n}\n\n:host([emphasis=default]) span {\n  color: var(--zui-color-grid-cell-text-default-enabled);\n}\n\n:host(:not([disabled])[emphasis=default]:hover) button span {\n  color: var(--zui-color-grid-cell-text-default-hover);\n}\n\n:host([disabled][emphasis=selected]) button {\n  opacity: 0.5;\n}\n\n:host([emphasis=selected]) span {\n  color: var(--zui-color-grid-cell-text-selected);\n}\n\n:host([emphasis=subtle]) span {\n  opacity: 0.5;\n  color: var(--zui-color-grid-cell-text-subtle);\n}\n\nbutton {\n  background: transparent;\n  border: var(--zui-picker-grid-cell-border) transparent;\n  height: 100%;\n  /* reset browser default margin and padding to prevent cut off numbers */\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\nspan {\n  font: var(--zui-typography-caption);\n  overflow: hidden;\n  margin-bottom: 2px;\n  max-height: calc(var(--zui-picker-grid-cell-height) - calc(var(--zui-gu) * 1));\n  display: block;\n}")}`;
let h = class extends a {
  constructor() {
    super(...arguments), this.disabled = !1, this.emphasis = "default";
  }
  static get styles() {
    return [d, u];
  }
  focus(t = {
    preventScroll: !0
  }) {
    return e(this, void 0, void 0, function* () {
      if (!this.disabled) {
        (yield this._pickerGridCellButton).focus(t);
      }
    });
  }
  blur() {
    return e(this, void 0, void 0, function* () {
      (yield this._pickerGridCellButton).blur();
    });
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", this._handleClick);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this._handleClick), super.disconnectedCallback();
  }
  _handleClick() {
    this.focus();
  }
  render() {
    return i`<button ?disabled="${this.disabled}" value="${c(this.value)}"><span><slot></slot></span></button>`;
  }
};
t([r({
  reflect: !0,
  type: Boolean
})], h.prototype, "disabled", void 0), t([r({
  reflect: !0,
  type: String
})], h.prototype, "value", void 0), t([r({
  reflect: !0
})], h.prototype, "emphasis", void 0), t([s("button")], h.prototype, "_pickerGridCellButton", void 0), h = t([l("zui-picker-grid-cell")], h);
export { h as GridCell };
